import { gql, useQuery } from '@nerdwallet/apollo';
import { TablePress } from './types';

interface useTablePressProps {
  useArticlesData: boolean;
  tablePressId: number;
}

export const GET_TABLEPRESS_DATA_QUERY = gql`
  query getTablePressData($tableId: ID!) {
    table(input: { identifier: $tableId }) {
      id
      link
      title
      columns {
        id
        heading
      }
      data
    }
  }
`;

const useTablePress = ({
  useArticlesData,
  tablePressId,
}: useTablePressProps) => {
  const { data, error } = useQuery<TablePress>(GET_TABLEPRESS_DATA_QUERY, {
    variables: {
      tableId: `${tablePressId}`,
      skip: !useArticlesData,
    },
  });

  if (error) {
    console.error('Error executing tablepress data query', error);
    return { data: [], error };
  }

  try {
    const columnId = data?.table?.columns?.[0]?.id || '';
    const rows = data?.table?.data?.map((row) => {
      return Number(
        row?.[columnId].children?.[0].props?.children?.props?.children?.[0]
      );
    });

    return { data: rows as number[], error };
  } catch (e) {
    console.error('Error processing tablepress data:', e);
    return { data: [], error: e };
  }
};

export default useTablePress;
